<template>
  <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Configuração Pendente"
    :escToClose="false"
  >
    <b-row class="form-group">
      <b-col sm="12">
        <p>
          <b>
            Para iniciar a abertura de caixa, é necessário ter ao menos um caixa
            configurado.</b
          >
        </p>
      </b-col>
    </b-row>
    <Form :onSubmit="handleSave">
      <b-row>
        <b-col md="3" lg="3" sm="12">
          <Input
            label="Caixa"
            mask="###"
            id="identification"
            v-model="modal.data.identification"
            labelBold
            :description="errorValue('identification')"
            :error="!!errorValue('identification')"
          />
        </b-col>
        <b-col md="9" lg="9" sm="12">
          <Input
            id="username"
            ref="username"
            class="input"
            label="Nome do Usuário"
            v-model="modal.data.username"
            :disabled="true"
            labelBold
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <Label bold htmlFor="ativo">Status</Label>
        </b-col>
        <b-col>
          <checkbox-switch
            v-model="modal.data.status"
            id="ativo"
            style="margin: 0px !important"
          />
        </b-col>
      </b-row>
    </Form>
    <div class="confirm-buttons">
      <Button type="error" @click="closePDV()">Sair do PDV</Button>
      <Button
        :disabled="validationsToCreateCheckout(modal.data.identification)"
        type="success"
        @click="handleSave()"
      >
        Cadastrar Novo Caixa
      </Button>
    </div>
  </Modal>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { Button, Modal } from '../../../../../../components';

import {
  Form,
  Input,
  CheckboxSwitch,
  Label,
} from '../../../../../../components/Form';

import { validationsToCreateCheckout } from '../../helpers/validations';

export default {
  name: 'ModalConfigCheckout',
  components: {
    Modal,
    Button,
    Form,
    CheckboxSwitch,
    Label,
    Input,
  },
  data() {
    return {
      users: [],
      configurations: [],
      errors: {},
      modal: {
        open: false,
        data: {},
      },
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  async mounted() {
    await this.getData();
  },
  computed: {
    ...mapState('pdv', ['checkouts']),
    ...mapState('client', ['currentUser']),
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('pdv', ['getCheckouts', 'setCheckouts']),
    ...mapActions('client', ['getCurrentUser']),
    validationsToCreateCheckout,
    closePDV() {
      window.location.href = '/';
    },
    async getData() {
      await this.getCurrentUser();
      this.modal.data.status = true;
      this.modal.data.user = this.currentUser;
      this.modal.data.username = this.currentUser.name;
    },
    errorValue(field) {
      return this.errors[field];
    },
    async handleSave() {
      const { schema, validate } = this.$validate;
      const schemaConfiguration = schema.object().shape({
        identification: schema.number().required(),
        user: schema.string().required(),
      });
      this.errors = {};
      const validations = await validate(schemaConfiguration, this.modal.data);
      if (!validations.status) {
        this.errors = validations.data;
        return;
      }
      const data = {
        id: this.modal.data.id ?? undefined,
        userId: this.currentUser.id,
        identification: this.modal.data.identification.padStart(3, '0'),
        status: !!this.modal.data.status,
      };
      try {
        this.setLoading(true);
        await this.setCheckouts(data, this.modal.data.id);
        this.$alert.success('Configuração salva com sucesso.');
        this.setLoading(false);
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.setLoading(false);
      }
      window.location.reload();
    },
  },
};
</script>
